import {
  GET_REPORT_SCHEMA,
  GET_REPORT_SCHEMA_SUCCESS,
  GET_REPORT_SCHEMA_FAILURE,
  RUN_REPORT,
  RUN_REPORT_SUCCESS,
  RUN_REPORT_FAILURE,
} from './actionType';

export const getReportSchema = () => ({
  type: GET_REPORT_SCHEMA,
});

export const getReportSchemaSuccess = (payload) => ({
  type: GET_REPORT_SCHEMA_SUCCESS,
  payload,
});

export const getReportSchemaFailure = (payload) => ({
  type: GET_REPORT_SCHEMA_FAILURE,
  payload,
});

export const runReport = (payload) => ({
  type: RUN_REPORT,
  payload,
});

export const runReportSuccess = (payload) => ({
  type: RUN_REPORT_SUCCESS,
  payload,
});

export const runReportFailure = (payload) => ({
  type: RUN_REPORT_FAILURE,
  payload,
});
